import { useState, useEffect } from 'react';
import { Typography } from '../../atoms/typography/typography';
import { StyledDiv } from '../../common/components/styled-div';

interface NoInternetHeaderProps {
  state: boolean | null;
  time?: number;
}

export const NoInternetHeader = ({
  state,
  time = 3000,
}: NoInternetHeaderProps) => {
  const [showHeader, setShowHeader] = useState(state);

  useEffect(() => {
    if (state === false) {
      setShowHeader(true);
    } else if (state === true) {
      setShowHeader(true);
      const timer = setTimeout(() => {
        setShowHeader(false);
      }, time);

      return () => clearTimeout(timer);
    }
  }, [state, time]);

  if (!showHeader) return null;

  return (
    <StyledDiv
      height="24px"
      width="100%"
      alignItem="center"
      justifyContent="center"
      background={state ? '--md-ref-secondary-30' : '--md-ref-neutral-0'}
    >
      <Typography variant="textBodyLargeNeutral100">
        {state ? 'You’re online' : 'No internet'}
      </Typography>
    </StyledDiv>
  );
};
